module.exports = __webpack_public_path__ + "static/media/modal-demo.6bde3f87.png";